type NavigationReadyHandler = (() => void) | null

let navigationReadyHandler: NavigationReadyHandler = null

export const setNavigationReadyHandler = (handler: NavigationReadyHandler) => {
  navigationReadyHandler = handler
}

export const notifyNavigationReady = () => {
  navigationReadyHandler?.()
}
